import * as React from 'react';
// import PropTypes from 'prop-types';
import './container.scss';

export const Container = (props) => {
    return (<div {...props} className={`container ${props.className}`}>
        {props.children}
    </div>);
}

export const Grid = (props) => {
    return (<div {...props} className={`grid ${props.className} ${props.columns && `column${props.columns}` || 'auto'} `}>
        {props.children}
    </div>);
}
// Grid.propTypes = {
// 	columns: PropTypes.number
// };
export default Container;